import auth from "../middleware/auth";

const Home = () => import("../components/Views/Home.vue");
const QuadroHorario = () =>
  import("../components/Views/Graduacao/QuadroDeHorarios.vue");
const HorarioProfessores = () =>
  import("../components/Views/Graduacao/HorarioProfessores.vue");

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Graduação", link: "/graduacao" }
];

const graduacao = [
  {
    path: "/graduacao",
    redirect: "/graduacao/quadro-de-horarios"
  },
  {
    path: "/graduacao",
    component: Home,
    children: [
      {
        path: "/graduacao/quadro-de-horarios",
        component: QuadroHorario,
        name: "Quadro de Horários",
        meta: {
          middleware: auth,
          breadcrumb
        }
      },
      {
        path: "/graduacao/horario-professores",
        component: HorarioProfessores,
        name: "Carga Horária dos Professores",
        meta: {
          middleware: auth,
          breadcrumb
        }
      }
    ]
  }
];

export default graduacao;



// WEBPACK FOOTER //
// ./src/routes/graduacao.js